import * as React from 'react';

export const LazyHorizonNOKExclusion = React.lazy(() => import('./component'));
